import { createContext, useContext } from 'react'

import type { Service } from '~publish/pages/Community/graphqlEnums'

import type { CommunityEntity, DismissActionType } from '../types'

export type BulkActionsEntity = CommunityEntity

export type BulkActionsMenuContextValue = {
  channelIds: string[]
  channelService?: Service
  postId?: string
  entity: BulkActionsEntity
  onResolvingChange?: (isResolving: boolean) => void
  // Requests a bulk resolve, opening the confirmation dialog for the active
  // entity (comments or mentions). Both the resolve menu items and the coach
  // mark route through this so the two entry points can never drift.
  requestResolve: (actionType: DismissActionType) => void
}

const BulkActionsMenuContext =
  createContext<BulkActionsMenuContextValue | null>(null)

export function useBulkActionsMenuContext(): BulkActionsMenuContextValue {
  const context = useContext(BulkActionsMenuContext)
  if (!context) {
    throw new Error(
      'useBulkActionsMenuContext must be used within BulkActionsMenu',
    )
  }
  return context
}

export { BulkActionsMenuContext }
